import React from 'react';
import Modal from './Modal';

interface PermissionRequestProps {
  permissionStatus: 'prompt' | 'granted' | 'denied';
  status: string;
  onRequestPermission: () => void;
  onClose: () => void;
}

const PermissionRequest: React.FC<PermissionRequestProps> = ({
  permissionStatus,
  status,
  onRequestPermission,
  onClose
}) => {
  if (permissionStatus === 'denied') {
    return (
      <Modal
        isOpen={true}
        onClose={onClose}
        title="Location Access Required"
      >
        <div className="permission-container">
          <p>To use the time in/out feature, you need to allow location access.</p>
          <p>To enable location access:</p>
          <ol>
            <li>Click the location icon in your browser's address bar</li>
            <li>Select "Allow" for this site</li>
            <li>Refresh the page</li>
          </ol>
          <p className="error-text">{status || 'Location permission denied'}</p>
          <button 
            className="permission-btn" 
            onClick={onRequestPermission}
          >
            Try Again
          </button>
        </div>
      </Modal>
    );
  }

  if (permissionStatus === 'prompt') {
    return (
      <Modal
        isOpen={true}
        onClose={onClose}
        title="Location Permission Required"
      >
        <div className="permission-container">
          <p>To use the time in/out feature, we need access to your location.</p>
          <p>This helps us verify that you're at your designated work location.</p>
          <button 
            className="permission-btn"
            onClick={onRequestPermission}
          >
            Allow Location Access
          </button>
        </div>
      </Modal>
    );
  }

  return null;
};

export default PermissionRequest;
